// extracted by mini-css-extract-plugin
module.exports = {"root":"ContentLoader_root__8sSLH","loader":"ContentLoader_loader__1xFp_","disabled":"ContentLoader_disabled__1r0qG"};